module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red-b5ceeff2abacd3913dd112167c1aeb97.png";